import { render, staticRenderFns } from "./ossUpload.vue?vue&type=template&id=1efff24a"
import script from "./ossUpload.vue?vue&type=script&lang=js"
export * from "./ossUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports